<template>
    <b-card title="Add Role">
        <b-form>
            <b-form-group
                id="fieldset-name"
                label="Name"
                label-for="input-name"
            >
                <b-form-input
                    id="input-name"
                    v-model="model.name"
                    trim
                ></b-form-input>
            </b-form-group>

            <b-form-group
                id="fieldset-permissions"
                label="Permissions"
                label-for="input-permissions"
            >
                <permission-groups
                    v-model="model.permissions"
                    :options="permissions_list"
                ></permission-groups>
            </b-form-group>
            <b-row>
                <b-col>
                    <b-button
                        @click="cancel()"
                        variant="secondary"
                        class="float-right"
                        :disabled="submitting ? true : false"
                        >Cancel</b-button
                    >

                    <b-button
                        @click="create()"
                        variant="primary"
                        class="float-right"
                        :disabled="submitting ? true : false"
                        >{{
                            submitting ? 'Creating Role...' : 'Create Role'
                        }}</b-button
                    >
                </b-col>
            </b-row>
        </b-form>
    </b-card>
</template>

<script>
import PermissionGroups from '@/components/PermissionGroups'

export default {
    name: 'create-role-form',
    components: { PermissionGroups },
    props: [],
    data: () => {
        return {
            model: {
                name: '',
            },
            submitting: false,
            hasErrors: false,
        }
    },
    computed: {
        permissions_list() {
            return this.$store.state.permissions.permissions_list
        },
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        create() {
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.submitting = true
                    this.$store
                        .dispatch('roles/create', this.model)
                        .then(() => {
                            this.$emit('success')
                        })
                        .catch(() => {})
                        .finally(() => {
                            this.submitting = false
                        })
                }
            })
        },
    },
    mounted: function () {
        this.$store.dispatch('permissions/all')
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>